/* idk */
(function () {
  'use strict';

  // ---- Media gate: enable only below 1024px -------------------------------
  const MQ = window.matchMedia('(max-width: 1023.98px)');

  function addL(el, type, fn, opts){
    el.addEventListener(type, fn, opts);
    (el._infSwipeHandlers ||= []).push([type, fn, opts]);
  }
  function removeAllL(el){
    if (!el._infSwipeHandlers) return;
    for (const [type, fn, opts] of el._infSwipeHandlers) try{ el.removeEventListener(type, fn, opts); }catch(_){}
    el._infSwipeHandlers = [];
  }

  function enhanceInfiniteRow(row){
    if (!row || row.dataset.infiniteSwipe === '1') return;

    // make row scrollable even if theme sets o-hidden
    row.style.setProperty('overflow-x', 'auto', 'important');
    row.style.setProperty('overflow-y', 'hidden', 'important');
    row.style.setProperty('-webkit-overflow-scrolling', 'touch');
    row.style.touchAction = 'auto';
    row.classList.add('js-infinite-swipe');
    row.dataset.infiniteSwipe = '1';
    if (!row.hasAttribute('tabindex')) row.tabIndex = 0;

    const tracks = row.querySelectorAll('.brand-item-scroll');
    const pause  = () => tracks.forEach(t => t.style.animationPlayState = 'paused');
    const resume = () => tracks.forEach(t => t.style.animationPlayState = 'running');

    // nuke native image drag
    row.querySelectorAll('img').forEach(img => img.setAttribute('draggable','false'));
    addL(row, 'dragstart', (e) => {
      if (e.target && (e.target.tagName === 'IMG' || e.target.closest('img'))) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    // thresholds
    const THRESH = 8; // px before deciding
    const BIAS   = 3; // horizontal must beat vertical by this

    // state
    let down=false, dragging=false, intent='undecided';
    let sx=0, sy=0, lastX=0, moved=0, resumeTimer=null;

    function lockH(e){
      intent='h'; dragging=true;
      row.classList.add('is-dragging');
      pause();
      if (row.setPointerCapture && e && e.pointerId != null) {
        try { row.setPointerCapture(e.pointerId); } catch(_) {}
      }
    }
    function lockV(){
      intent='v'; dragging=false;
      row.classList.remove('is-dragging');
      if (!resumeTimer) resumeTimer=setTimeout(resume,700);
    }
    function suppressClickOnce(ev){
      ev.preventDefault(); ev.stopPropagation();
      row.removeEventListener('click', suppressClickOnce, true);
    }

    // ---------- Pointer Events path ----------
    function onPointerDown(e){
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      down=true; dragging=false; intent='undecided'; moved=0;
      sx=e.clientX; sy=e.clientY; lastX=e.clientX;

      // desktop: prevent native image/link drag immediately
      if (e.pointerType === 'mouse' && e.cancelable) e.preventDefault();

      clearTimeout(resumeTimer); resumeTimer=null;
      pause();
    }
    function onPointerMove(e){
      if (!down) return;
      const dx = e.clientX - sx;
      const dy = e.clientY - sy;

      if (intent === 'undecided') {
        if (Math.abs(dx) > THRESH && Math.abs(dx) > Math.abs(dy) + BIAS) { lockH(e); }
        else if (Math.abs(dy) > THRESH && Math.abs(dy) >= Math.abs(dx) + BIAS) { lockV(); return; }
        else { return; }
      }
      if (!dragging) return;

      const delta = e.clientX - lastX;
      row.scrollLeft -= delta;
      lastX = e.clientX;
      moved += Math.abs(delta);

      if (e.cancelable) e.preventDefault(); // kill text selection / drag while dragging
    }
    function onPointerUp(e){
      if (!down) return;
      down=false;
      if (dragging && moved > 5) row.addEventListener('click', suppressClickOnce, true);
      dragging=false; intent='undecided';
      row.classList.remove('is-dragging');
      if (row.releasePointerCapture && e?.pointerId != null) {
        try { row.releasePointerCapture(e.pointerId); } catch(_) {}
      }
      resumeTimer=setTimeout(resume,700);
    }

    // ---------- Touch fallback (iOS Safari quirks) ----------
    function getTouch(e){ return e.touches && e.touches[0] ? e.touches[0] : (e.changedTouches && e.changedTouches[0]); }

    function onTouchStart(e){
      const t = getTouch(e); if (!t) return;
      down=true; dragging=false; intent='undecided'; moved=0;
      sx=t.clientX; sy=t.clientY; lastX=t.clientX;
      clearTimeout(resumeTimer); resumeTimer=null;
      pause();
      // do NOT preventDefault here; we still want vertical scroll if user goes vertical
    }
    function onTouchMove(e){
      if (!down) return;
      const t = getTouch(e); if (!t) return;
      const dx = t.clientX - sx;
      const dy = t.clientY - sy;

      if (intent === 'undecided') {
        if (Math.abs(dx) > THRESH && Math.abs(dx) > Math.abs(dy) + BIAS) { lockH(); }
        else if (Math.abs(dy) > THRESH && Math.abs(dy) >= Math.abs(dx) + BIAS) { lockV(); return; }
        else { return; }
      }
      if (!dragging) return;

      const delta = t.clientX - lastX;
      row.scrollLeft -= delta;
      lastX = t.clientX;
      moved += Math.abs(delta);

      // IMPORTANT: once horizontal, stop page from trying to scroll
      if (e.cancelable) e.preventDefault();
    }
    function onTouchEnd(){
      if (!down) return;
      down=false;
      if (dragging && moved > 5) row.addEventListener('click', suppressClickOnce, true);
      dragging=false; intent='undecided';
      row.classList.remove('is-dragging');
      resumeTimer=setTimeout(resume,700);
    }

    // attach listeners (capture so we beat IMG/A defaults)
    if ('PointerEvent' in window) {
      addL(row, 'pointerdown', onPointerDown, { passive:false, capture:true });
      addL(row, 'pointermove',  onPointerMove,  { passive:false, capture:true });
      addL(row, 'pointerup',    onPointerUp,    { passive:true,  capture:true });
      addL(row, 'pointercancel',onPointerUp,    { passive:true,  capture:true });
      addL(row, 'mouseleave',   (e)=>{ if(down) onPointerUp(e); }, { passive:true, capture:true });
    } else {
      // Touch fallback (older iOS / Android WebView)
      addL(row, 'touchstart', onTouchStart, { passive:false, capture:true });
      addL(row, 'touchmove',  onTouchMove,  { passive:false, capture:true });
      addL(row, 'touchend',   onTouchEnd,   { passive:true,  capture:true });
      addL(row, 'touchcancel',onTouchEnd,   { passive:true,  capture:true });
      // Optional mouse fallback if needed:
      addL(row, 'mousedown', (e)=>{ onPointerDown(e); }, { passive:false, capture:true });
      addL(row, 'mousemove', (e)=>{ onPointerMove(e); }, { passive:false, capture:true });
      addL(row, 'mouseup',   (e)=>{ onPointerUp(e);   }, { passive:true,  capture:true });
      addL(row, 'mouseleave',(e)=>{ if(down) onPointerUp(e); }, { passive:true, capture:true });
    }
  }

  function teardownInfiniteRow(row){
    if (!row || row.dataset.infiniteSwipe !== '1') return;

    // remove listeners
    removeAllL(row);

    // restore styles/classes/attrs
    row.classList.remove('js-infinite-swipe','is-dragging');
    row.removeAttribute('data-infinite-swipe');
    row.style.removeProperty('overflow-x');
    row.style.removeProperty('overflow-y');
    row.style.removeProperty('-webkit-overflow-scrolling');
    row.style.removeProperty('touch-action');
    if (row.getAttribute('tabindex') === '0') row.removeAttribute('tabindex');

    // resume theme marquee
    row.querySelectorAll('.brand-item-scroll').forEach(t => {
      t.style.animationPlayState = '';
    });

    // allow images to be draggable again
    row.querySelectorAll('img[draggable="false"]').forEach(img => img.removeAttribute('draggable'));
  }

  function toggleAll(scope=document){
    const rows = scope.querySelectorAll('.brand-slider .halo-row.brand-layout--infinite');
    rows.forEach(row => {
      if (MQ.matches) enhanceInfiniteRow(row);
      else teardownInfiniteRow(row);
    });
  }

  // initial + live section events + MQ changes
  document.addEventListener('DOMContentLoaded', () => toggleAll());
  document.addEventListener('shopify:section:load',    (e) => toggleAll(e.target));
  document.addEventListener('shopify:section:select',  (e) => toggleAll(e.target));
  document.addEventListener('shopify:section:reorder', (e) => toggleAll(e.target));
  (MQ.addEventListener ? MQ.addEventListener('change', () => toggleAll())
                       : MQ.addListener(() => toggleAll()));
})();


/* idk */
(function () {
  'use strict';

  // ---- helpers -------------------------------------------------------------

  // clone child nodes of a track until we reach a target width multiplier
  function buildLoopBuffer(track, minMultiplier) {
    // strip any previous clones
    track.querySelectorAll('[data-clone="1"]').forEach(n => n.remove());

    // measure one "unit" width (original children only)
    const originals = Array.from(track.children).filter(n => n.dataset.clone !== '1');
    const unitWidth = originals.reduce((w, n) => w + n.getBoundingClientRect().width, 0);

    if (unitWidth === 0) return 0;

    // duplicate children until track width >= minMultiplier * unitWidth
    // (we do child-level cloning to avoid nesting tracks inside tracks)
    let copies = 0;
    while (track.scrollWidth < unitWidth * minMultiplier && copies < 20) {
      for (const node of originals) {
        const c = node.cloneNode(true);
        c.dataset.clone = '1';
        // keep a11y clean: avoid duplicate IDs & remove tabbability in clones
        if (c.id) c.id = '';
        c.querySelectorAll('[id]').forEach(el => el.id = '');
        c.querySelectorAll('a,button,[tabindex]').forEach(el => el.tabIndex = -1);
        c.setAttribute('aria-hidden', 'true');
        track.appendChild(c);
      }
      copies++;
    }
    return unitWidth;
  }

  // throttle scroll work with rAF
  function onScrollRAF(el, fn) {
    let ticking = false;
    el.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => { fn(); ticking = false; });
        ticking = true;
      }
    }, { passive: true });
  }

  // ---- main enhancer -------------------------------------------------------

  function enhanceInfiniteRow(row){
    if (!row || row.dataset.infiniteSwipe === '1') return;

    // force scrollability even if theme sets o-hidden
    row.style.setProperty('overflow-x', 'auto', 'important');
    row.style.setProperty('overflow-y', 'hidden', 'important');
    row.style.setProperty('-webkit-overflow-scrolling', 'touch');
    row.style.touchAction = 'pan-y';
    row.classList.add('js-infinite-swipe');
    row.dataset.infiniteSwipe = '1';
    row.tabIndex = 0;

    const tracks = Array.from(row.querySelectorAll('.brand-item-scroll'));
    if (!tracks.length) return;

    // 1) Build a minimal loop buffer for each track
    // We want at least ~3x the original content span to hide "teleports"
    const unitWidths = tracks.map(t => buildLoopBuffer(t, 3));
    const unit = Math.max(0, ...unitWidths);            // use the widest track as our loop span
    row.dataset.loopUnit = String(unit);

    // 2) Start centered inside the buffer so you can drag both ways
    if (unit > 0) row.scrollLeft = unit;

    // 3) Respect reduced motion: pause marquee if user prefers it
    const mql = window.matchMedia('(prefers-reduced-motion: reduce)');
    const setMotion = () => {
      tracks.forEach(t => t.style.animationPlayState = mql.matches ? 'paused' : 'running');
    };
    setMotion();
    mql.addEventListener?.('change', setMotion);

    // 4) Drag/swipe (desktop & mobile), no wheel hijack
    const THRESH = 8, BIAS = 3;
    let down=false, dragging=false, intent='undecided';
    let sx=0, sy=0, lastX=0, moved=0, resumeTimer=null;

    const pause = () => tracks.forEach(t => t.style.animationPlayState = 'paused');
    const resume = () => tracks.forEach(t => t.style.animationPlayState = mql.matches ? 'paused' : 'running');

    function lockH(e){
      intent='h'; dragging=true;
      row.classList.add('is-dragging');
      pause();
      if (row.setPointerCapture && e.pointerId != null) {
        try { row.setPointerCapture(e.pointerId); } catch(_) {}
      }
    }
    function lockV(){
      intent='v'; dragging=false;
      row.classList.remove('is-dragging');
      if (!resumeTimer) resumeTimer=setTimeout(resume,700);
    }

    function onDown(e){
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      down=true; dragging=false; intent='undecided'; moved=0;
      sx=e.clientX; sy=e.clientY; lastX=e.clientX;
      // stop native image/link drag ASAP on desktop
      if (e.pointerType === 'mouse' && e.cancelable) e.preventDefault();
      clearTimeout(resumeTimer); resumeTimer=null;
      pause();
    }

    function onMove(e){
      if (!down) return;
      const dx = e.clientX - sx;
      const dy = e.clientY - sy;

      if (intent === 'undecided') {
        if (Math.abs(dx) > THRESH && Math.abs(dx) > Math.abs(dy) + BIAS) lockH(e);
        else if (Math.abs(dy) > THRESH && Math.abs(dy) >= Math.abs(dx) + BIAS) { lockV(); return; }
        else return;
      }
      if (!dragging) return;

      const delta = e.clientX - lastX;
      row.scrollLeft -= delta;
      lastX = e.clientX;
      moved += Math.abs(delta);
      if (e.cancelable) e.preventDefault();   // kill image/text selection while dragging
    }

    function onUp(e){
      if (!down) return;
      down=false;

      if (dragging && moved > 5) {
        row.addEventListener('click', suppressOnce, true); // block click-through
      }
      dragging=false; intent='undecided';
      row.classList.remove('is-dragging');
      resumeTimer=setTimeout(resume,700);

      if (row.releasePointerCapture && e?.pointerId != null) {
        try { row.releasePointerCapture(e.pointerId); } catch(_) {}
      }
    }

    function suppressOnce(ev){
      ev.preventDefault(); ev.stopPropagation();
      row.removeEventListener('click', suppressOnce, true);
    }

    row.addEventListener('pointerdown', onDown, { passive:false, capture:true });
    row.addEventListener('pointermove',  onMove, { passive:false, capture:true });
    row.addEventListener('pointerup',    onUp,   { passive:true,  capture:true });
    row.addEventListener('pointercancel',onUp,   { passive:true,  capture:true });
    row.addEventListener('mouseleave',   (e)=>{ if(down) onUp(e); }, { passive:true, capture:true });

    // 5) Seamless wrap: keep scrollLeft within the middle band so it never ends
    function wrapIfNeeded(){
      const span = +row.dataset.loopUnit || 0;
      if (!span) return;
      const x = row.scrollLeft;

      // stay inside [0.25*span, 1.75*span] by shifting by ±span when needed
      // this avoids visible jumps because we have ~3x buffer width.
      if (x < span * 0.25) {
        row.scrollLeft = x + span;
      } else if (x > span * 1.75) {
        row.scrollLeft = x - span;
      }
    }
    onScrollRAF(row, wrapIfNeeded);

    // 6) Rebuild on resize (fonts/images can change widths)
    const ro = new ResizeObserver(() => {
      const unitWidths2 = tracks.map(t => buildLoopBuffer(t, 3));
      const newUnit = Math.max(0, ...unitWidths2);
      row.dataset.loopUnit = String(newUnit);
      if (newUnit > 0) row.scrollLeft = newUnit; // recenter
    });
    ro.observe(row);
  }

  function init(scope=document){
    scope.querySelectorAll('.brand-slider .halo-row.brand-layout--infinite').forEach(enhanceInfiniteRow);
  }

  // expose for Shopify section reloads
  function enhanceInfiniteRow(row){ enhanceInfiniteRow = enhanceInfiniteRow; } // no-op placeholder
  // actual init hooks
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load',    e => init(e.target));
  document.addEventListener('shopify:section:select',  e => init(e.target));
  document.addEventListener('shopify:section:reorder', e => init(e.target));
})();


/* dimmy dim dim on hovity hover hover */
(function () {
  'use strict';

  // ------------ CONFIG ------------
  const CFG = {
    desktopMQ: '(min-width: 1024px) and (hover: hover) and (pointer: fine)',
    sliderRoot: '.brand-slider',            // preferred wrapper
    trackSel:   '.brand-item-scroll',       // track containing items
    rootAttr:   'data-brand-slider-root',   // we tag real sliders with this
    htmlAttr:   'data-brand-dim',           // set "1" when dimming is active
    itemActive: 'data-active-item',         // set "1" on the one undimmed item
    styleId:    'brand-dim-v9',
    dimOpacity: 0.5,
    transMs:    120
  };

  // Remove old style blocks (defensive)
  ['brand-slider-dim-active-desktop','brand-slider-dim-desktop-v7','brand-slider-dim-v8',
   'brand-slider-dimming-style-v6','brand-slider-dimming-style-v5','brand-slider-dimming-style-scoped',
   'brand-hover-dimming-style-v4','brand-hover-dimming-style-v3','brand-hover-dimming-style-v2',
   'brand-hover-dimming-style'
  ].forEach(id => { const n = document.getElementById(id); if (n) n.remove(); });

  // CSS (scoped + !important so theme CSS can’t override)
  function injectStyle() {
    if (document.getElementById(CFG.styleId)) return;
    const s = document.createElement('style');
    s.id = CFG.styleId;
    s.textContent = `
      @media ${CFG.desktopMQ} {
        [${CFG.rootAttr}="1"] ${CFG.trackSel} > * {
          transition: opacity ${CFG.transMs}ms ease;
          will-change: opacity;
        }
        html[${CFG.htmlAttr}="1"] [${CFG.rootAttr}="1"] ${CFG.trackSel} > * {
          opacity: ${CFG.dimOpacity} !important;
        }
        html[${CFG.htmlAttr}="1"] [${CFG.rootAttr}="1"] ${CFG.trackSel} > *[${CFG.itemActive}="1"] {
          opacity: 1 !important;
        }
        @media (prefers-reduced-motion: reduce) {
          [${CFG.rootAttr}="1"] ${CFG.trackSel} > * { transition: none; }
        }
      }
    `;
    document.head.appendChild(s);
  }

  // Desktop gate
  const mq = window.matchMedia(CFG.desktopMQ);
  const isDesktop = () => mq.matches;

  // Tag only real slider roots (must contain a track)
  function tagRoots(scope = document) {
    const roots = new Set();
    scope.querySelectorAll(CFG.trackSel).forEach(track => {
      const root = track.closest(CFG.sliderRoot) || track.closest('.shopify-section') || track.parentElement;
      if (root) roots.add(root);
    });
    roots.forEach(r => r.setAttribute(CFG.rootAttr, '1'));
    return Array.from(roots);
  }

  // Returns the direct item (child of track) under a DOM target/point
  function directItemFrom(el) {
    if (!el) return null;
    const track = el.closest(`${CFG.sliderRoot} ${CFG.trackSel}, [${CFG.rootAttr}="1"] ${CFG.trackSel}`);
    if (!track) return null;
    // ensure we return the *direct* child of the track
    for (const child of track.children) {
      if (child.contains(el)) return child;
    }
    return null;
  }

  // State
  let unsubs = [];
  let activeItem = null;
  let rafPending = false;
  let lastPoint = { x: 0, y: 0 };

  const setHtmlDim = (on) => {
    const html = document.documentElement;
    if (on) html.setAttribute(CFG.htmlAttr, '1');
    else html.removeAttribute(CFG.htmlAttr);
  };

  function setActive(next) {
    if (next === activeItem) return;
    if (activeItem) activeItem.removeAttribute(CFG.itemActive);
    activeItem = next || null;
    if (activeItem) {
      activeItem.setAttribute(CFG.itemActive, '1');
      setHtmlDim(true);
    } else {
      setHtmlDim(false);
    }
  }

  // rAF-coalesced hover resolver using elementFromPoint
  function scheduleResolve() {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(() => {
      rafPending = false;
      if (!isDesktop()) { setActive(null); return; }
      const el = document.elementFromPoint(lastPoint.x, lastPoint.y);
      const item = directItemFrom(el);
      setActive(item);
    });
  }

  function bind(scope = document) {
    injectStyle();
    tagRoots(scope);

    // Pointer tracking (desktop only)
    const onPointerMove = (e) => {
      if (!isDesktop() || e.pointerType !== 'mouse') return;
      lastPoint.x = e.clientX;
      lastPoint.y = e.clientY;
      scheduleResolve();
    };

    const onPointerLeaveWindow = (e) => {
      // If pointer left viewport, clear
      if (!e.relatedTarget && !e.toElement) setActive(null);
    };

    // Keyboard focus support
    const onFocusIn = (e) => {
      if (!isDesktop()) return;
      const item = directItemFrom(e.target);
      if (item) setActive(item);
    };
    const onFocusOut = () => {
      if (!isDesktop()) return;
      setTimeout(() => {
        const item = directItemFrom(document.activeElement);
        setActive(item || null);
      }, 0);
    };

    // Page visibility/blur safety
    const onBlur = () => setActive(null);
    const onHidden = () => { if (document.hidden) setActive(null); };

    document.addEventListener('pointermove', onPointerMove, { passive: true });
    window.addEventListener('mouseout', onPointerLeaveWindow, { passive: true });
    document.addEventListener('focusin',  onFocusIn,  { passive: true });
    document.addEventListener('focusout', onFocusOut, { passive: true });
    window.addEventListener('blur', onBlur, { passive: true });
    document.addEventListener('visibilitychange', onHidden, { passive: true });

    unsubs.push(() => {
      document.removeEventListener('pointermove', onPointerMove, { passive: true });
      window.removeEventListener('mouseout', onPointerLeaveWindow, { passive: true });
      document.removeEventListener('focusin',  onFocusIn,  { passive: true });
      document.removeEventListener('focusout', onFocusOut, { passive: true });
      window.removeEventListener('blur', onBlur, { passive: true });
      document.removeEventListener('visibilitychange', onHidden, { passive: true });
    });

    // Initial: nothing dimmed
    setActive(null);
  }

  function teardown() {
    unsubs.forEach(fn => { try { fn(); } catch(_){} });
    unsubs = [];
    setActive(null);
  }

  function enableIfDesktop(scope = document) {
    teardown();
    if (isDesktop()) bind(scope);
  }

  // Bootstrap after full load; rebind on Shopify section events; respond to MQ changes
  window.addEventListener('load', () => enableIfDesktop());
  document.addEventListener('shopify:section:load',    e => enableIfDesktop(e.target));
  document.addEventListener('shopify:section:select',  e => enableIfDesktop(e.target));
  document.addEventListener('shopify:section:reorder', e => enableIfDesktop(e.target));
  (mq.addEventListener ? mq.addEventListener('change', () => enableIfDesktop())
                       : mq.addListener(() => enableIfDesktop()));
})();

(function () {
    function initAdvertisementImagePopup(container = document) {
        const images = container.querySelectorAll('.advertisement-image img');

        images.forEach((img) => {
            if (img.dataset.popupInitialized === 'true') return;

            img.dataset.popupInitialized = 'true';
            img.style.cursor = 'zoom-in';

            img.addEventListener('click', function () {
                let imageUrl = img.currentSrc || img.src;

                // Remove Shopify image sizing parameters if present
                try {
                    const url = new URL(imageUrl, window.location.origin);
                    url.searchParams.delete('width');
                    imageUrl = url.toString();
                } catch (e) {}

                const popup = document.createElement('div');
                popup.className = 'custom-image-popup';

                popup.innerHTML = `
                    <button
                        type="button"
                        class="custom-image-popup__close"
                        aria-label="Close image"
                    >
                        &times;
                    </button>

                    <img
                        class="custom-image-popup__image"
                        src="${imageUrl}"
                        alt="${img.alt || ''}"
                    >
                `;

                document.body.appendChild(popup);
                document.body.classList.add('image-popup-open');

                function closePopup() {
                    popup.remove();
                    document.body.classList.remove('image-popup-open');
                    document.removeEventListener('keydown', handleEscape);
                }

                function handleEscape(event) {
                    if (event.key === 'Escape') {
                        closePopup();
                    }
                }

                popup.addEventListener('click', function (event) {
                    if (
                        event.target === popup ||
                        event.target.closest('.custom-image-popup__close')
                    ) {
                        closePopup();
                    }
                });

                document.addEventListener('keydown', handleEscape);
            });
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        initAdvertisementImagePopup();
    });

    // Shopify Theme Editor / dynamic section reload support
    document.addEventListener('shopify:section:load', function (event) {
        initAdvertisementImagePopup(event.target);
    });
})();